import { gql } from '@apollo/client'
import { commentaryData, liveInningData, oversData, scorecardData } from '@graphql/match'

export const FULL_SCOREBOARD = gql`
subscription FetchLiveInningsData($input: liveInningsInput) {
  fetchLiveInningsData(input: $input) {
    ${scorecardData}
  }
}
`

// export const GET_COMMENTARY_SUBSCRIPTION = gql`
// subscription ListFinalMatchCommentaries($input: oListFinalMatchCommentaryFrontInput) {
//   listFinalMatchCommentaries(input: $input) {
//     ${commentaryData}
//   }
// }
// `

export const GET_COMMENTARY_SUBSCRIPTION = gql`
subscription ListMatchCommentaries($input: oListCommentariesInput) {
  listMatchCommentaries(input: $input) {
    ${commentaryData}
  }
}
`

export const GET_RECENT_OVER = gql`
subscription Subscription($input: oListMatchOverFrontInput) {
  listMatchOvers(input: $input) {
    ${oversData}
  }
}
`
export const MATCH_DETAIL_FOR_CLIENT = gql`
  query GetMatchById($input: oGetMatchByIdInput) {
    getMatchById(input: $input) {
#      oCricTezzScore {
#        sFirstCircle
#      }
      sBallEvent
      oTeamScoreA {
        sScoresFull,
        sScores,
        sOvers
      }
      oTeamScoreB {
        sScoresFull,
        sScores,
        sOvers
      }
      sStatusNote
      nLatestInningNumber
      oLiveScore {
        nRunrate
        sRequiredRunrate
      }
      oMom {
        sFullName
        sThumbUrl
        eTagStatus
        oImg {
          sAttribute
          sCaption
          sText
          sUrl
        }
        oSeo {
          sSlug
        }
      }
      oMos {
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
    }
  }
`

export const GET_MATCH_HEADER = gql`
subscription GetMatchBySlug($input: oListCommentariesInput) {
  getMatchBySlug(input: $input) {
    oMatchDetailsFront {
#       oCricTezzScore {
#         sFirstCircle
#       }
      sBallEvent
      oTeamScoreA {
        sScoresFull
        sScores
        sOvers
      }
      oTeamScoreB {
        sScoresFull
        sScores
        sOvers
      }
      sStatusNote
      nLatestInningNumber
      oLiveScore {
        nRunrate
        sRequiredRunrate
      }
      oMom {
        sFullName
        eTagStatus
        sThumbUrl
        oSeo {
          sSlug
        }
      }
      oMos {
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
    }
  }
}
`

export const GET_MATCH_STATUS = gql`
  subscription GetMatchBySlug($input: oListCommentariesInput) {
    getMatchBySlug(input: $input) {
      oMatchDetailsFront {
        sStatusStr
        oStatus {
          sText
          sValue
        }
        sLiveGameStatusStr
        oLiveGameStatus {
          sValue
          sText
        }
        aInning {
          sName
        }
        nLatestInningNumber
      }
    }
  }
`

export const GET_LIVE_DATA = gql`
subscription Subscription($input: oListCommentariesInput) {
  getMatchBySlug(input: $input) {
    LiveInnings {
      ${liveInningData}
    }
  }
}
`
